import { createSlice } from "@reduxjs/toolkit";

const modal = createSlice({
  name: "modal",
  initialState: {
    modalStatus: "hide", // show, hide
    modalName: "",
    modalData: {},
  },
  reducers: {
    showModal: (state, action) => {
      state.modalStatus = "show";
      state.modalName = action.payload.modalName;
      state.modalData = action.payload.modalData;
    },
    hideModal: (state, action) => {
      state.modalStatus = "hide";
      state.modalName = "";
      state.modalData = {};
    },
  },
});

export const { showModal, hideModal } = modal.actions;
export default modal.reducer;
